import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flash"
export default class extends Controller {
  static values = { 
    timeout: { type: Number, default: 5000 } 
  }

  connect() {
    this.checkAndStartTimer()
    
    // Watch for content changes (e.g., from Turbo Stream updates)
    this.observer = new MutationObserver((mutations) => {
      // Check if actual content changed (not just attributes)
      const hasContentChange = mutations.some(mutation => 
        mutation.type === 'childList' || 
        mutation.type === 'characterData'
      )
      
      if (hasContentChange) {
        this.checkAndStartTimer()
      }
    })
    
    this.observer.observe(this.element, {
      childList: true,
      subtree: true,
      characterData: true
    })
  }

  disconnect() {
    clearTimeout(this.timer)
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  checkAndStartTimer() {
    // Clear any existing timer
    clearTimeout(this.timer)
    
    // Check if there is content to show
    const content = this.element.innerHTML.trim()
    if (content.length > 0 && !this.isEmptyFlash(content)) {
      // Make sure the element is visible
      this.element.style.display = 'block'
      this.startDismissTimer()
    }
  }

  isEmptyFlash(html) {
    // Check if the flash only contains empty elements (no actual message)
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = html
    const textContent = tempDiv.textContent.trim()
    return textContent.length === 0
  }

  startDismissTimer() {
    this.timer = setTimeout(() => {
      this.dismiss()
    }, this.timeoutValue)
  }

  dismiss() {
    this.element.style.transition = "opacity 0.5s ease"
    this.element.style.opacity = "0"
    
    setTimeout(() => {
      this.element.style.display = 'none'
      this.element.innerHTML = ''
      this.element.style.opacity = "1"
    }, 500)
  }
}
